import { component as defineComponent } from 'flightjs'; // eslint-disable-line no-restricted-imports
import $ from 'jquery'; // eslint-disable-line no-restricted-imports

function FilterList() {
    this.defaultAttrs({
        input: '[data-filter-list-input]',
        item: '[data-filter-list-item]',
    });

    this.after('initialize', function() {
        this.on('input', {
            input: this.filterList,
        });
    });

    this.filterList = function() {
        const inputText = this.select('input')
            .val()
            .toLowerCase();

        this.select('item')
            .attr('data-filter-list-item', true)
            .each(function() {
                if (
                    $(this)
                        .text()
                        .toLowerCase()
                        .indexOf(inputText) === -1
                ) {
                    $(this).attr('data-filter-list-item', false);
                }
            });
    };
}

export default defineComponent(FilterList);



// WEBPACK FOOTER //
// ./src/js/component_ui/filter-list.js